export const DEFAULT_WIDGET_LAUNCHER_ICON = 'chat';

export const WIDGET_LAUNCHER_ICONS = [
  DEFAULT_WIDGET_LAUNCHER_ICON,
  'message',
  'inbox',
  'headset',
];

export const WIDGET_LAUNCHER_ICON_PATHS = {
  chat: {
    viewBox: '0 0 240 240',
    path: 'M240.808 240.808H122.123C56.6994 240.808 3.45695 187.562 3.45695 122.122C3.45695 56.7031 56.6994 3.45697 122.124 3.45697C187.566 3.45697 240.808 56.7031 240.808 122.122V240.808Z',
  },
  message: {
    viewBox: '0 0 24 24',
    path: 'M20 3H4C2.9 3 2 3.9 2 5v12c0 1.1.9 2 2 2h11.17L20 22.83V5c0-1.1-.9-2-2-2Zm-3 11H7v-2h10v2Zm0-3H7V9h10v2Zm0-3H7V6h10v2Z',
  },
  inbox: {
    viewBox: '0 0 24 24',
    path: 'M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-1 10h-3.18C15.4 15.16 14.3 16 13 16h-2c-1.3 0-2.4-.84-2.82-2H5V7h14v7Z',
  },
  headset: {
    viewBox: '0 0 24 24',
    path: 'M12 2C7.03 2 3 6.03 3 11v5c0 1.1.9 2 2 2h3v-8H5.08C5.56 6.61 8.47 4 12 4s6.44 2.61 6.92 6H16v8h2v1h-4v2h4c1.1 0 2-.9 2-2v-1c1.1 0 2-.9 2-2v-5c0-4.97-4.03-9-10-9Z',
  },
};
